import { hasChinese } from '@starflow/app/utils';
import { setProjectState } from '@starflow/app/store';
import { notifyError, notifySuccess } from '@shakkerai/pro-components';
import { decode } from 'js-base64';
import { eventBus } from '@starflow/app/helpers';
import { resetFlowData, createNewNodeId } from '../../../helpers/flow';
import { FlOW_SOCKET_INFO, FlOW_TYPE } from '../constants';
import { registerType } from '../../../constants';
import { pickLocalLibflow } from '../../../utils/file';

export const isGtLen = (str = '') => {
  return hasChinese(str) ? str.length > 8 : str.length > 16;
};

export const contentParse = (content, nodeMap, units) => {
  try {
    const localFlowData = JSON.parse(decode(content)) ?? {};
    const { registerType: rtp, projectId, data } = localFlowData;
    if (rtp === registerType.FLOW) {
      if (projectId && data?.edge_lists && data.edge_lists.length && data?.nodes && data.nodes.length) {
        const res = resetFlowData(localFlowData);
        eventBus.emit(FlOW_SOCKET_INFO, {
          flowId: res.flowId,
          tp: FlOW_TYPE.NEW,
        });
        notifySuccess('上传成功');
      } else {
        notifyError('上传失败,请检查数据');
      }
      return;
    }
    if (rtp === registerType.UNIT) {
      const id = createNewNodeId(data.id);
      const newNodeMap = { ...nodeMap };
      newNodeMap[id] = {
        id,
        data: {
          ...data,
          id,
        },
        registerType: registerType.UNIT,
      };

      setProjectState({
        units: { ...units, nodes: [id, ...units.nodes] },
        nodeMap: newNodeMap,
        isFoldFlow: false,
        currentNodeId: id,
      });
      notifySuccess('上传成功');
      return;
    }
    notifyError('上传失败,请检查数据');
  } catch (err) {
    notifyError(`上传失败,请检查数据:${err}`);
  }
};

// 接口获取流数据
export const pickPresetData = async (url, nodeMap, units) => {
  if (!url) return;
  try {
    const res = await fetch(url);
    const flowInfo = await res.text();
    flowInfo && contentParse(flowInfo, nodeMap, units);
  } catch (err) {
    console.log(err);
  }
};

// 本地获取流数据
export const pickLocaleFile = async (nodeMap, units) => {
  const res = await pickLocalLibflow();
  if (res.code !== 0) {
    notifyError(res.message);
    return;
  }

  var reader = new FileReader();
  reader.readAsText(res.data);
  reader.onload = function () {
    contentParse(this.result, nodeMap, units);
  };
};
